import { request } from '@/shared/api/request'
import type { GenerateAccepted } from './jobs'
import { etagHeaders, workItemPath } from './paths'

export function assembleLesson(workItemId: number): Promise<{ payload?: unknown; etag?: string }> {
  return request.post(workItemPath(workItemId, '/assemble-lesson'))
}

export function putLessonPlan(
  workItemId: number,
  payload: Record<string, unknown>,
  etag?: string | null,
): Promise<{ payload?: unknown; etag?: string }> {
  return request.put(
    workItemPath(workItemId, '/lesson-plan'),
    { payload, etag },
    etagHeaders(etag),
  )
}

export function generatePptOutline(workItemId: number): Promise<GenerateAccepted> {
  return request.post(workItemPath(workItemId, '/ppt-outline'))
}

export function putPptOutline(
  workItemId: number,
  pages: unknown[],
  outlineId?: string | null,
  etag?: string | null,
): Promise<{ etag?: string; outlineId?: string }> {
  return request.put(
    workItemPath(workItemId, '/ppt-outline'),
    { pages, outlineId, etag },
    etagHeaders(etag),
  )
}

export function confirmPptOutline(
  workItemId: number,
  pages?: unknown[] | null,
  outlineId?: string | null,
): Promise<{ etag?: string; outlineId?: string }> {
  return request.post(workItemPath(workItemId, '/ppt-outline/confirm'), {
    pages,
    outlineId,
  })
}

export function generateLectureNotes(
  workItemId: number,
  batchIndex = 0,
): Promise<GenerateAccepted> {
  return request.post(workItemPath(workItemId, '/lecture-notes'), undefined, {
    params: { batch_index: batchIndex },
  })
}

export function generateLectureNotesRunAll(
  workItemId: number,
  options?: { restart?: boolean },
): Promise<GenerateAccepted> {
  return request.post(workItemPath(workItemId, '/lecture-notes/run-all'), undefined, {
    params: options?.restart ? { restart: true } : undefined,
  })
}

export function putLectureNotes(
  workItemId: number,
  pages: unknown[],
  outlineId?: string | null,
  etag?: string | null,
): Promise<{ etag?: string; outlineId?: string }> {
  return request.put(
    workItemPath(workItemId, '/lecture-notes'),
    { pages, outlineId, etag },
    etagHeaders(etag),
  )
}

export function confirmLectureNotes(
  workItemId: number,
  pages?: unknown[] | null,
  outlineId?: string | null,
): Promise<{ etag?: string }> {
  return request.post(workItemPath(workItemId, '/lecture-notes/confirm'), {
    pages,
    outlineId,
  })
}
